import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";

export default (date:Date)=>{
    const toStringify = new Date(getGermanIsoString(date))
    return `${toStringify.getDate().toString().padStart(2, "0")}.${(date.getMonth()+1).toString().padStart(2, "0")}.${date.getFullYear().toString().padStart(2, "0")} ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
}